import React from "react";
import SquareButton from "../../ui/SquareButton";
import DeleteIcon from "@material-ui/icons/Delete";

const DeleteButton = ({ onClick }) => {
  return (
    <div>
      <SquareButton onClick={onClick}>
        <DeleteIcon fontSize="small" />
      </SquareButton>
    </div>
  );
};

export default DeleteButton;
